import styled from "styled-components";

export const StyledHtmlRenderer = styled.div`
  ${({ theme, $size = 'sm' }) => theme.typographyRebrand.body[$size]}
  color: ${p => p.theme.c.text.primary};

  p {
    white-space: pre-wrap;
  }

  strong {
    font-weight: var(--typography-font-weight-bold);
  }
  
  ul {
    padding: 0px;
    padding-left: ${p => p.theme.unit(2)};
  }

  h1 {
    ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  }

  h2 {
    ${({ theme }) => theme.typographyRebrand.heading.xl}
  }
  
  h3 {
    ${({ theme }) => theme.typographyRebrand.heading.lg}
  }
  
  h4 {
    ${({ theme }) => theme.typographyRebrand.heading.md}
  }
`;
